import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { MaintenanceService } from 'src/app/core/services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private maintenanceService: MaintenanceService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // 503 - Maintenance mode
        if (error?.status === 503) {
          this.maintenanceService.activate();
        }
        throw error;
      })
    );
  }
}
